// extracted by mini-css-extract-plugin
export default {"build-invoice":"BuildInvoice_build-invoice__Tx6BY","scroll-frame":"BuildInvoice_scroll-frame__zDA3Z","example-invoice__img":"BuildInvoice_example-invoice__img__c-Vde"};